<mat-card class="bib-table col-12">
  <mat-card-content class="p0">
    <div class="flex justify-between items-center mx2">
      <span class="h6 caps muted ml1 sort-label">Bibliography Generator</span>
      <div class="flex flex-column items-end px2 pt2 pb1">
        <div class="flex items-center sort-controls">
          <span class="h6 caps muted mr1 sort-label">Sort By</span>
          <mat-button-toggle-group
            class="sort-toggle-group"
            [value]="sortOrder()"
            (change)="setSortOrder($event.value)"
          >
            <mat-button-toggle value="none" [disabled]="!allCslReferencesCited()">
              Appearance
            </mat-button-toggle>
            <mat-button-toggle value="author" [disabled]="!allCslReferencesCited()">
              Author Date
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        @if (!allCslReferencesCited()) {
          <small class="h6 muted">Cite all references to enable sorting</small>
        }
        <small class="h6 muted">Final citation style will be generated at export</small>
      </div>
    </div>

    @if (rows.length === 0) {
      <div class="px3 py2 muted">No bibliography references available.</div>
    } @else {
      <div class="col-12 table-scroll-wrap">
        <div
          class="bib-grid"
          role="grid"
          [class.no-index]="sortOrder() !== 'none'"
          aria-label="Bibliography references"
        >
          <div role="row" class="grid-header-row">
            @if (sortOrder() === 'none') {
              <div role="columnheader" class="grid-header center">#</div>
            }
            <div role="columnheader" class="grid-header">Reference</div>
            <div role="columnheader" class="grid-header center">Cited in</div>
            <div role="columnheader" class="grid-header center">Actions</div>
          </div>

          @for (row of rows; track row.referenceKey) {
            <div
              role="row"
              class="grid-row"
              tabindex="0"
              [attr.aria-label]="'Change how this reference appears: ' + row.title"
              (click)="onActivate(row, $event)"
              (keydown)="onRowKeydown($event, row)"
            >
              @if (sortOrder() === 'none') {
                <div role="gridcell" class="grid-cell index-cell center muted">
                  <span class="meta">{{ row.rowIndex }}</span>
                </div>
              }
              <div role="gridcell" class="grid-cell reference-cell">
                <div class="reference-text" matTooltip="Click to change how this reference appears">
                  @if (row.exportFormat === 'custom' && row.customText) {
                    <div
                      class="reference-title"
                      [innerHTML]="sanitizeCustomText(row.customText)"
                    ></div>
                  } @else {
                    <div class="reference-title">{{ row.title }}</div>
                  }
                  @if (row.meta) {
                    <div class="meta">{{ row.meta }}</div>
                  }
                </div>
                @if (
                  row.exportFormat === 'custom' ||
                  row.missingMetadata.length > 0 ||
                  ((row.source === 'ai' || row.source === 'plain-text') && !row.reviewed)
                ) {
                  <div class="reference-issues" aria-label="Reference issues">
                    @if (row.exportFormat === 'custom') {
                      <span class="issue-chip issue-chip--custom">Custom</span>
                    }
                    @for (field of row.missingMetadata; track field) {
                      <span
                        class="issue-chip issue-chip--warning"
                        [matTooltip]="
                          field === 'author'
                            ? 'Missing author - required for author-date styles.'
                            : getMissingMetadataLabel(field)
                        "
                      >
                        {{ getMissingMetadataLabel(field) }}
                      </span>
                    }
                    @if ((row.source === 'ai' || row.source === 'plain-text') && !row.reviewed) {
                      <span
                        class="issue-chip issue-chip--review"
                        matTooltip="Review this reference"
                      >
                        Needs review
                      </span>
                    }
                  </div>
                }
                @if (hasAuthorDateCompatibilityRisk(row)) {
                  <small><i>May not work in author-date styles</i></small>
                }
              </div>
              <div role="gridcell" class="grid-cell cited-in-cell center">
                @if (row.citedIn.length === 0) {
                  <span class="h6 muted brt-cited-text">{{ getCitedInLabel(row) }}</span>
                } @else {
                  <div class="chips" aria-label="Cited in chapters">
                    @for (occurrence of row.citedIn; track occurrence.partId) {
                      <button
                        type="button"
                        class="chip"
                        [matTooltip]="'Go to chapter:' + occurrence.title"
                        (click)="onCitedInClick(row, occurrence, $event)"
                      >
                        {{ occurrence.title }}
                      </button>
                    }
                  </div>
                }
              </div>
              <div role="gridcell" class="grid-cell actions-cell">
                <div class="flex justify-center items-center actions-controls">
                  <button
                    mat-icon-button
                    aria-label="Delete reference"
                    matTooltip="Delete reference"
                    (click)="onDelete(row, $event)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
